import React from 'react'
import { useNavigate } from 'react-router-dom'
import { OnboardingLayout } from '../components/layout/OnboardingLayout'
import { useRepeatFlow } from '../hooks/useRepeatFlow'
import LegalRepresentativeStep from '../components/onboarding/steps/LegalRepresentativeStep'
import { authService } from '../services/authService'

const LegalRepresentativePage: React.FC = () => {
  const navigate = useNavigate()
  // En la 2da solicitud en adelante es parte del recorrido abreviado (sin stepper).
  const { isRepeat, resolveNextUrl } = useRepeatFlow()

  const steps = [
    { id: '1', title: '', description: '', status: 'completed' as const },
    { id: '2', title: '', description: '', status: 'completed' as const },
    { id: '3', title: '', description: '', status: 'completed' as const },
    { id: '4', title: '', description: '', status: 'completed' as const },
    { id: '5', title: '', description: '', status: 'current' as const },
    { id: '6', title: '', description: '', status: 'pending' as const },
  ]

  const handleComplete = async (stepData: any) => {
    console.log('Legal Representative data:', stepData)

    const nextUrl = isRepeat
      ? await resolveNextUrl('legal_representative_data')
      : '/onboarding/documents'
    try {
      console.log(
        '📍 Updating progressURL after successful CIEC consultation...'
      )
      const creditAppId = await authService.getCurrentCreditApplicationId()

      if (creditAppId) {
        await authService.updateCreditApplicationProgress(creditAppId, nextUrl)
        console.log('✅ ProgressURL updated successfully to:', nextUrl)
      } else {
        console.warn(
          '⚠️ No credit application ID found, skipping progressURL update'
        )
      }
    } catch (progressError) {
      console.error('❌ Error updating progressURL:', progressError)
      // No detener el flujo si falla la actualización del progreso
    }
    navigate(nextUrl)
  }

  return (
    <OnboardingLayout steps={steps} showStepper={!isRepeat}>
      <LegalRepresentativeStep onComplete={handleComplete} />
    </OnboardingLayout>
  )
}

export default LegalRepresentativePage
